var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 38,
    viewBox: "0 0 76 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 76,
    height: 38,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAAAmCAYAAABu+H0XAAABgElEQVRogeWa6w6DIAyFj2Tv/8ouWeZiGBXoHT3/pkbbL+wU0m77vqPS+cJW33yISAblAlbr9xN0yaBQNx4KrcugdB7svehOGmLwmkj4eOHdfG1qMRTG6rnTapvOvTZ9qw9lFCsHLjAsDo0de/l6EteXVoTGjfnDqVQXuAGsAE4S549N/ZeUVMDM0CSxXe70/x6YVEZoarBwYfp38TWRX7Vu9KrkytDEftXSyLZitWKgYu6URvdhq/iaql+1NLNxzQ7NHBYYO/2sxUDd3Clxj0aZoJn5VUuSs2R0MTA1d0oSYKIPC6G5+FVLUmDSADiJh8GCEjA4FgM3c6ekBewcGEcjINz9qiVtYDAoBiHmTskCGBR9LdSvWrICBgVo6WBhss3G0RG413nSvAVoucLO8uhluvRLvYDBOCG35rInMBgl5tqJ9wYG5QTdxxasTZ+StBiEzXdErLCzOImHDsNEA8MkgPDJoQzAMAgixZhVFmDoAEkzkxZl+pTqYpBreA/AG5PDTE+jTyNIAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/Down_Arrow.371e738d8daf735e8985759ac575e827.svg";
export { ForwardRef as ReactComponent };